export default function generatePosterUrlFromVideoRoot(videoRoot) {
  return `/av/${videoRoot}/PNG/frame_0000.png`;
}
